
define('tpl!taoQtiItem/qtiXmlRenderer/tpl/portableInfoControl', ['handlebars'], function(hb){ 
return hb.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, functionType="function", escapeExpression=this.escapeExpression, helperMissing=helpers.helperMissing, self=this;

function program1(depth0,data,depth1) {
  
  var buffer = "", stack1;
  buffer += "\n                <"
    + escapeExpression(((stack1 = ((stack1 = (depth1 && depth1.ns)),stack1 == null || stack1 === false ? stack1 : stack1.pic)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "lib id=\""
    + escapeExpression((typeof depth0 === functionType ? depth0.apply(depth0) : depth0))
    + "\"/>\n                ";
  return buffer;
  }

  buffer += "<infoControl ";
  stack1 = (helper = helpers.join || (depth0 && depth0.join),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.attributes), "=", " ", "\"", options) : helperMissing.call(depth0, "join", (depth0 && depth0.attributes), "=", " ", "\"", options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += ">\n    <"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.ns)),stack1 == null || stack1 === false ? stack1 : stack1.pic)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "portableInfoControl infoControlTypeIdentifier=\"";
  if (helper = helpers.typeIdentifier) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.typeIdentifier); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" hook=\"";
  if (helper = helpers.entryPoint) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.entryPoint); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">\n\n        <"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.ns)),stack1 == null || stack1 === false ? stack1 : stack1.pic)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "resources location=\"http://imsglobal.org/pci/1.0.15/sharedLibraries.xml\">\n            <"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.ns)),stack1 == null || stack1 === false ? stack1 : stack1.pic)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "libraries>\n                ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.libraries), {hash:{},inverse:self.noop,fn:self.programWithDepth(1, program1, data, depth0),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n            </"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.ns)),stack1 == null || stack1 === false ? stack1 : stack1.pic)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "libraries>\n        </"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.ns)),stack1 == null || stack1 === false ? stack1 : stack1.pic)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "resources>\n\n        ";
  stack1 = (helper = helpers.portableElementProperties || (depth0 && depth0.portableElementProperties),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.properties), ((stack1 = (depth0 && depth0.ns)),stack1 == null || stack1 === false ? stack1 : stack1.pic), options) : helperMissing.call(depth0, "portableElementProperties", (depth0 && depth0.properties), ((stack1 = (depth0 && depth0.ns)),stack1 == null || stack1 === false ? stack1 : stack1.pic), options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n        <"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.ns)),stack1 == null || stack1 === false ? stack1 : stack1.pic)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "markup>\n            ";
  if (helper = helpers.markup) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.markup); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        </"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.ns)),stack1 == null || stack1 === false ? stack1 : stack1.pic)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "markup>\n\n    </"
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.ns)),stack1 == null || stack1 === false ? stack1 : stack1.pic)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "portableInfoControl>\n</infoControl>";
  return buffer;
  });
});

